// utils/settings.js
export const CHALLENGE_FOCUS_EVENT = 'pfandpirat:challenge-focus-change';

function readSetting(key, fallback = null) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return fallback;
    }
    return window.localStorage.getItem(key);
  } catch {
    return fallback;
  }
}

function writeSetting(key, value) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }
    window.localStorage.setItem(key, value);
  } catch {}
}

export function isXpSoundEnabled() {
  return readSetting('xpSound') !== 'off';
}

export function isKorkVoiceEnabled() {
  return readSetting('korkVoice') !== 'off';
}

export function setKorkVoiceEnabled(enabled) {
  writeSetting('korkVoice', enabled ? 'on' : 'off');
}

export function isChallengeFocusEnabled() {
  return readSetting('challengeFocus') === 'on';
}

export function setChallengeFocusEnabled(enabled) {
  writeSetting('challengeFocus', enabled ? 'on' : 'off');

  try {
    window.dispatchEvent(new CustomEvent(CHALLENGE_FOCUS_EVENT, { detail: { enabled: Boolean(enabled) } }));
  } catch {}
}
